import React, { useEffect, useState, Fragment } from 'react'

import './index.scss'

import Button from '../../Components/Button'
import TipsGo from '../Components/TopEnterTips'
import Search from '../Components/SingerSearcher'

import AppealDialog from '../Components/AppealDialog'

import Dialog from '../../Components/Dialog'

import history from '../../History'

import e from '../../Utils/Event'
import {replaceHttpsImg} from '../../Utils/Utils'
import ChangeBindDialog from '../Components/ChangeBindDialog'
import LightMobileCall from '@kugou/light-mobilecall'
import mobileLog from '../../Utils/Utils/mobileLog'

function Card(props) {
  let { singerPic, platform, singerName, singerId, settleStatus, reason, keyword, showTips,
    canClaim, canBind, type, area, identity, genre, introduce, kugouSingerId, setBindDialogVisible, setInfo, cardInfo, setPhone, source } = props

  const [errSingerPic, setErrSingerPic] = useState('')
  const errSrc = '//y.gtimg.cn/music/photo_new/T017M000000Cmb6i28tb7c.png'
  let stStatus = settleStatus;

  if(canBind){
    stStatus = 2;
  }
  const statusMap = {
    0: {
      text: '立即认领',
      to: '/enter/',
    },
    1: {
      text: '已入驻'
    },
    2: {
      text: '换绑'
    }
  }

  function getPhone(cb){
    e.emit('loading', true)
    window.$req('getPhoneBySingerId', { singerId: singerId, singerSource: source }).then(res => {
      e.emit('loading', false)
      cb && cb(res);
    }).catch(err => {
      e.emit('loading', false)
      if (err.message) {
        window.$Msg(err.message)
      }
    });
  }

  function goGet() {
    setInfo(cardInfo);
    if ( stStatus == 2 ){
      getPhone((res)=>{
        //截图后四位
        setPhone(res.data && res.data.substr(-4,4))
        setBindDialogVisible(true)
      });
      return;
    }
    let path = statusMap[stStatus].to
    if (reason) {
      return path ? window.$Msg(reason) : showTips(reason)
    } else {
      if (!path) return;
    }
    window.$getUserStatus(({ status }) => {
      let objToPass = {
        name: singerName,
        pic: errSingerPic || singerPic || errSrc,
        id: singerId,
        status,
        platform
      }
      if (canClaim && platform === 4) {
        //tme机构认领需要禁止编辑的
        Object.assign(objToPass, {
          type,
          area,
          identity,
          genre,
          introduce
        })
      }
      check({ id: singerId, platform }, () => {
        let realPath = path + window.encodeURIComponent(JSON.stringify(objToPass))
        history.go(realPath)
      })
    })

  }

  function check({ id, platform }, callback) {
    window.$req('checkSingerCanGet', { id, platform }).then(res => {
      let data = res.data
      if (data.result) {
        callback && callback()
      } else {
        showTips(data.resultInfo)
        // window.$Msg(data.resultInfo)
      }
    }).catch(e => {
      window.$req('服务异常，请稍后重试')
    })
  }

  function HilightName(name, keyword) {
    let index = name.indexOf(keyword)
    let kwLen = keyword.length
    let before = name.slice(0, index)
    let mid = name.slice(index, index + kwLen)
    let after = name.slice(index + kwLen)
    return <Fragment>{before}<span className="highlight">{mid}</span>{after}</Fragment>
  }

  function imgOnError(e) {
    let target = e.target
    target.onerror = null;
    target.src = errSrc
    setErrSingerPic(errSrc)
  }

  return (<div className="card">
    <img src={replaceHttpsImg(singerPic) || errSrc} alt="" onError={imgOnError} onClick={
      // goGet
      () => {
        kugouSingerId && window.LC.mobileCall(703, { singerId: kugouSingerId })
      }
    } />
    <p className="name">{HilightName(singerName, keyword)}</p>
    <section className={"btn" + (stStatus != 1 ? '' : ' off')} onClick={goGet}>
      {statusMap[stStatus].text}</section>
  </div>)
}

export default function GetSingerList(props) {

  const [alreadyFetch, setAreadyFetch] = useState(false)
  const [appealDialogVisible, setAppealDialogVisible] = useState(false)
  const [cardList, setCardList] = useState([])

  const [keyword, setKeyword] = useState('')
  
  const [phone, setPhone] = useState('');

  const [ resultDialogVisible, setResultDialogVisible ] = useState( false )
  //结果传参
  const [ info, setInfo ] = useState( {} )
  //处理绑定结果
  function controlSetBindDialogVisible( visible ) {
    setResultDialogVisible( visible )
  }

  //提示弹窗
  const [showTipsDialog, setShowTipsDialog] = useState(false)
  const [tipsContent, setTipsContent] = useState('')

  function getSingerList(name) {
    mobileLog({
      a: 1133454,
      b: '点击',
      ft: '创作者开放平台_认领搜索歌手名页面点击搜索',
      r: '音乐人',
      svar1: name
    })
    if (!name.trim()) {
      return window.$Msg('请先输入歌手名字')
    }
    let iconRule1 = /[`~!@#$%^&*()_\-+=<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im
    let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
    if (iconRule1.test(name) || iconRule2.test(name)) {
      return window.$Msg('请不要输入特殊字符')
    }
    if (name.length > 60) {
      return window.$Msg('歌手名字请控制在60字内')
    }
    e.emit('loading', true)
    setKeyword(name)
    window.$req('searchSinger', { name }).then(res => {
      e.emit('loading', false)
      let data = res.data.singers[1]
      let dataTme = res.data.singers[4]
      let dataF = Array.isArray(data) ? data.map(ele => ({ ...ele, platform: ele.source })) : []
      let dataTmeF = Array.isArray(dataTme) ? dataTme.map(ele => ({ ...ele, platform: ele.source })) : []
      setCardList(dataF.concat(dataTmeF))
      setAreadyFetch(true)
    }).catch(err => {
      e.emit('loading', false)
      if (err.message) {
        window.$Msg(err.message)
      }
    })
  }

  function goEnter() {
    window.$getUserStatus(({ status }) => {
      history.go('/enter/' + window.encodeURIComponent(JSON.stringify({ status })))
    })
  }

  //提示弹窗
  function showTips(word) {
    setTipsContent(word)
    setShowTipsDialog(true)
  }

  useEffect(() => {
    getSingerList(window.decodeURIComponent(props.match.params.name))
  }, [props.match.params.name])

  useEffect(() => {
    LightMobileCall.mobileCall(1203)
    mobileLog({
      a: 1133455,
      b: '曝光',
      ft: '创作者开放平台_认领搜索歌手名页面曝光',
      r: '音乐人',
    })
  }, [])

  return (<div className="GetSingerList">
    <TipsGo type="appeal" tab={() => setAppealDialogVisible(true)} />

    <div className="container">
      <Search search={getSingerList} value={window.decodeURIComponent(props.match.params.name)} />

      <section className="cardContainer">
        {cardList.map((ele, index) => (<Card keyword={keyword} key={index} {...ele} showTips={showTips} setBindDialogVisible={controlSetBindDialogVisible} setInfo={setInfo} cardInfo={ele} setPhone={setPhone}/>))}
      </section>


      {alreadyFetch && !cardList.length &&
        <section className="noResult">
          <img src="https://webimg.kgimg.com/6a966ed6e4ac32fbea168f5c2f11363d.png" alt="" />
          <p className="desc">该音乐人还未入驻，赶快入驻成为音乐人吧</p>
          <Button text="立即入驻" fn={goEnter} />
        </section>}

      {
        !!cardList.length && <footer className="noMyAccount">
          <TipsGo type="enter" tab={goEnter} />
        </footer>
      }

    </div>

    <Dialog title="提示" visible={showTipsDialog} setVisible={setShowTipsDialog} btns={[{ text: '知道了', fn: () => setShowTipsDialog(false) }]}>
      <div className="getSingerListTipsContent">{tipsContent}</div>
    </Dialog>
    <AppealDialog visible={appealDialogVisible} setVisible={setAppealDialogVisible} btns={[{ text: '知道了', fn: () => setAppealDialogVisible(false) }]} />
    <ChangeBindDialog visible={resultDialogVisible} showphone={phone} setVisible={controlSetBindDialogVisible} info={info} />
  </div>)
}